<template>
<footer class="container-fluid footer">
  <div class="row">
    <div class="col-xs-12 text-center">© BrikBit Digital ShareS</div>
  </div>
</footer>
</template>

<script>
export default {
name: 'Footer'
}
</script>

<style>
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #e5e5e7;
   color: white;
   text-align: center;
   padding: 10px;
   font-size: 11px;
   text-align: center;
   color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue